import { render, staticRenderFns } from "./LeakEventHistory.vue?vue&type=template&id=ba36246a"
import script from "./LeakEventHistory.vue?vue&type=script&lang=js"
export * from "./LeakEventHistory.vue?vue&type=script&lang=js"
import style0 from "./LeakEventHistory.vue?vue&type=style&index=0&id=ba36246a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports